<template>
  <div class="card h-100 px-3 py-2">
    <table class="table table-no-top-border table-sm mb-0">
      <thead>
        <tr>
          <th role="columnheader">{{ trans('activity') }}</th>
          <th role="columnheader">{{ trans('schedule') }}</th>
          <th role="columnheader">{{ trans('start') }}</th>
          <th v-if="showSpots" class="d-none d-md-table-cell" role="columnheader" colspan="2">
            {{ trans('remaining_spots') }}
          </th>
          <th v-if="!showSpots" role="columnheader">&nbsp;</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="activity in block.meta.activities" :key="activity.id">
          <td>
            <span class="d-block">{{ activity.name }}</span>
            <small
              v-if="activity.spots_remaining != null"
              class="d-block d-md-none mt-2">
              {{ activity.spots_remaining }} {{ getSpotsRemaining(activity) }}
            </small>
            <b-button
              variant="branded"
              size="sm"
              :href="activity.url"
              target="_blank"
              class="d-inline-block mt-2 d-md-none"
            >
              {{ getButtonText(activity) }}
            </b-button>
          </td>
          <td>{{ activity.schedule_summary }}</td>
          <td>{{ getStart(activity) }}</td>
          <td v-if="showSpots" class="d-none d-md-table-cell" style="min-width: 50px;">
            {{ activity.spots_remaining }}
          </td>
          <td class="d-none d-md-table-cell">
            <b-button variant="branded" size="sm" class="text-nowrap" :href="activity.url" target="_blank">
              {{ getButtonText(activity) }}
            </b-button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  export default {
    props: {
      block: Object,
    },
    data() {
      return {
        trans: trans,
        moment: moment,
        currency: _.currency,
      }
    },
    computed: {
      showSpots() {
        return _.reduce(this.block.meta.activities, (show, activity) => {
          if (activity.spots_remaining != null) show = true
          return show
        }, false)
      },
    },
    methods: {
      getStart(activity) {
        return moment(activity.start).format('LLL')
      },
      getSpotsRemaining(activity) {
        return activity.spots_remaining != null ?
          trans('remaining_spot' + (activity.spots_remaining > 0 || activity.spots_remaining == 0 && window.lang == 'en' ? 's' : '')).toLowerCase() :
          null
      },
      getButtonText(activity) {
        return activity.price > 0 ? _.currency(activity.price) : trans('free')
      },
    },
  }
</script>